import "./style.css"
import { useState } from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap'
import { Link, Outlet, useParams } from 'react-router-dom'
import { useAgentContext } from '../../context/agent';
import { FaGlobe, FaWhatsapp, FaFacebook, FaCode, FaRocket, FaCheckCircle, FaClock, FaExternalLinkAlt } from 'react-icons/fa';
import PublishAgent from './PublishAgent';

function Deploy() {
    const { agentId } = useParams();
    const { getAgentById } = useAgentContext();
    const agent = getAgentById(agentId || "");
    const [activeTab, setActiveTab] = useState('web');
    
    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#1a1a1a', color: '#fff' }}>
            {agent && (
                <>
                    {!agent.isPublished ? (
                        <PublishAgent agent={agent} />
                    ) : (
                        <div>
                            {/* Header Section */}
                            <div style={{ backgroundColor: '#2d2d2d', borderBottom: '1px solid #444' }} className="sticky-top">
                                <Container fluid className="py-3">
                                    <Row className="align-items-center">
                                        <Col>
                                            <div className="d-flex align-items-center">
                                                <div className="bg-primary rounded p-2 me-3">
                                                    <FaRocket className="text-white" size={24} />
                                                </div>
                                                <div>
                                                    <h4 className="mb-0 text-light">Deploy & Integrate</h4>
                                                    <small style={{ color: '#999' }}>
                                                        Connect your agent to websites, apps, and messaging platforms
                                                    </small>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>

                            {/* Integration Options */}
                            <div className="p-4">
                                <div 
                                    className="p-4 rounded-3 mb-4"
                                    style={{ backgroundColor: "#2d2d2d", border: "1px solid #444" }}>
                                    <div className="d-flex align-items-center mb-4">
                                        <h4 className="text-light mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
                                            Available Integrations
                                        </h4>
                                    </div>

                                    <Row className="g-4">
                                        <Col lg={3} md={6}>
                                            <Card 
                                                as={Link}
                                                to="web"
                                                className="h-100 text-decoration-none"
                                                style={{ 
                                                    backgroundColor: activeTab === 'web' ? '#444' : '#333', 
                                                    border: activeTab === 'web' ? '2px solid #007bff' : '1px solid #555',
                                                    transition: 'all 0.2s ease',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => setActiveTab('web')}
                                            >
                                                <Card.Body className="text-center p-4">
                                                    <div 
                                                        className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "56px",
                                                            height: "56px",
                                                            backgroundColor: "#007bff",
                                                            borderRadius: "12px"
                                                        }}
                                                    >
                                                        <FaGlobe className="text-white" size={28} />
                                                    </div>
                                                    <h5 className="text-light mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>
                                                        Web Integration
                                                    </h5>
                                                    <p className="text-light mb-3" style={{ fontSize: "14px" }}>
                                                        Embed as floating widget or inline chat
                                                    </p>
                                                    <Badge bg="primary" className="px-2 py-1">
                                                        Ready
                                                    </Badge>
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        <Col lg={3} md={6}>
                                            <Card 
                                                as={Link}
                                                to="whatsapp"
                                                className="h-100 text-decoration-none"
                                                style={{ 
                                                    backgroundColor: activeTab === 'whatsapp' ? '#444' : '#333', 
                                                    border: activeTab === 'whatsapp' ? '2px solid #25D366' : '1px solid #555',
                                                    transition: 'all 0.2s ease',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => setActiveTab('whatsapp')}
                                            >
                                                <Card.Body className="text-center p-4">
                                                    <div 
                                                        className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "56px",
                                                            height: "56px",
                                                            backgroundColor: "#25D366",
                                                            borderRadius: "12px"
                                                        }}
                                                    >
                                                        <FaWhatsapp className="text-white" size={28} />
                                                    </div>
                                                    <h5 className="text-light mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>
                                                        WhatsApp Business
                                                    </h5>
                                                    <p className="text-light mb-3" style={{ fontSize: "14px" }}>
                                                        Connect via WhatsApp Business API
                                                    </p>
                                                    <Badge bg="success" className="px-2 py-1">
                                                        Available
                                                    </Badge>
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        {/* <Col lg={3} md={6}>
                                            <Card 
                                                className="h-100"
                                                style={{ 
                                                    backgroundColor: '#2a2a2a', 
                                                    border: '1px solid #555',
                                                    opacity: 0.7
                                                }}
                                            >
                                                <Card.Body className="text-center p-4">
                                                    <div 
                                                        className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "56px",
                                                            height: "56px",
                                                            backgroundColor: "#666",
                                                            borderRadius: "12px"
                                                        }}
                                                    >
                                                        <FaFacebook className="text-white" size={28} />
                                                    </div>
                                                    <h5 className="text-light mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>
                                                        Messenger
                                                    </h5>
                                                    <p className="text-light mb-3" style={{ fontSize: "14px" }}>
                                                        Facebook Messenger integration
                                                    </p>
                                                    <Badge bg="secondary" className="px-2 py-1 d-flex align-items-center justify-content-center">
                                                        <FaClock className="me-1" size={12} />
                                                        Coming Soon
                                                    </Badge>
                                                </Card.Body>
                                            </Card>
                                        </Col> */}

                                        <Col lg={3} md={6}>
                                            <Card 
                                            as={Link}
                                                to="api"
                                                className="h-100 text-decoration-none"
                                                style={{ 
                                                    backgroundColor: activeTab === 'api' ? '#444' : '#333', 
                                                    border: activeTab === 'api' ? '2px solid #007bff' : '1px solid #555',
                                                    transition: 'all 0.2s ease',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => setActiveTab('api')}

                                                // className="h-100"
                                                // style={{ 
                                                //     backgroundColor: '#2a2a2a', 
                                                //     border: '1px solid #555',
                                                //     opacity: 0.7
                                                // }}
                                            >
                                                <Card.Body className="text-center p-4">
                                                    <div 
                                                        className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "56px",
                                                            height: "56px",
                                                            backgroundColor: "#007bff",
                                                            borderRadius: "12px"
                                                        }}
                                                    >
                                                        <FaCode className="text-white" size={28} />
                                                    </div>
                                                    <h5 className="text-light mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>
                                                        REST API
                                                    </h5>
                                                    <p className="text-light mb-3" style={{ fontSize: "14px" }}>
                                                        Direct API access for custom integrations
                                                    </p>
                                                    {/* <Badge bg="secondary" className="px-2 py-1 d-flex align-items-center justify-content-center">
                                                        <FaClock className="me-1" size={12} />
                                                        Connect now
                                                    </Badge> */}
                                                    <Badge bg="primary" className="px-2 py-1">
                                                        Connect now
                                                    </Badge>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                                
                                {/* Integration Content */}
                                <div 
                                    className="p-4 rounded-3"
                                    style={{ backgroundColor: "#2d2d2d", border: "1px solid #444" }}
                                >
                                    <Outlet />
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default Deploy